



















import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class ModalConfirmPaymentFail extends Vue {
  private showModal = true;

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
